import type {
  GetUserPreferencesServiceConfig,
} from '@/services/httpServices/PreferenceServices/types';

import { createQueryKey } from './queryKeyUtils';

export function userPreferencesKeys(config?: GetUserPreferencesServiceConfig) {
  return createQueryKey(['userPreferences'], config);
}
